import { useQuery } from "react-query";

import { merchantStatementTabService } from "services";

type useStatementListQueryProps = {
	merchantId: string;
	fetchData: { page: number; sortBy: string };
};

const useStatementListQuery = ({
	merchantId,
	fetchData,
}: useStatementListQueryProps) => {
	const { page, sortBy } = fetchData;
	const queryResult = useQuery(
		["statementQueue", merchantId, page, sortBy],
		() =>
			merchantStatementTabService.getStatementList({
				merchantId,
				page,
				sortBy,
			}),
		{ retry: 0, cacheTime: 0 },
	);

	return queryResult;
};

export default useStatementListQuery;
